document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-mobile-nav-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');

  if (toggle && mobileNav) {
    toggle.addEventListener('click', () => {
      const isOpen = mobileNav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(isOpen));
    });
  }

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const mainImage = gallery.querySelector('[data-product-gallery-main-image]');
    const thumbnails = gallery.querySelectorAll('[data-product-gallery-thumb]');

    const setActiveMedia = (mediaId) => {
      if (!mainImage || !mediaId) return;

      const activeThumb = Array.from(thumbnails).find((thumb) => thumb.dataset.mediaId === String(mediaId));
      if (!activeThumb) return;

      const mediaUrl = activeThumb.dataset.mediaUrl;
      const mediaSrcset = activeThumb.dataset.mediaSrcset;
      const mediaAlt = activeThumb.dataset.mediaAlt || '';

      if (mediaUrl) {
        mainImage.src = mediaUrl;
      }

      if (mediaSrcset) {
        mainImage.srcset = mediaSrcset;
      }

      mainImage.alt = mediaAlt;
      mainImage.dataset.mediaId = String(mediaId);

      thumbnails.forEach((item) => item.classList.remove('is-active'));
      activeThumb.classList.add('is-active');
    };

    gallery.setActiveMedia = setActiveMedia;

    thumbnails.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        setActiveMedia(thumb.dataset.mediaId);
      });
    });
  });

  document.querySelectorAll('[data-variant-picker]').forEach((picker) => {
    const productLayout = picker.closest('.product-layout');
    const gallery = productLayout ? productLayout.querySelector('[data-product-gallery]') : null;
    const masterSelect = picker.querySelector('[data-variant-select]');
    const optionGroups = picker.querySelectorAll('[data-option-index]');
    const availabilityLabel = picker.querySelector('[data-variant-availability]');
    const priceTarget = picker.querySelector('[data-variant-price]');
    const addButton = picker.querySelector('[data-add-to-cart]');
    const visibleSelect = picker.querySelector('[data-variant-select-visible]');
    const variantJson = picker.querySelector('[type="application/json"][data-variants-json]');

    if (!masterSelect || !variantJson) return;

    const variants = JSON.parse(variantJson.textContent);

    const updateVariant = () => {
      const selectedOptions = Array.from(optionGroups).map((group) => {
        const checked = group.querySelector('input:checked');
        return checked ? checked.value : null;
      });

      const matchedVariant = variants.find((variant) =>
        selectedOptions.every((value, index) => !value || variant.options[index] === value)
      );

      if (!matchedVariant) return;

      masterSelect.value = matchedVariant.id;
      if (visibleSelect) {
        visibleSelect.value = matchedVariant.id;
      }

      if (availabilityLabel) {
        availabilityLabel.textContent = matchedVariant.available ? 'In stock' : 'Sold out';
      }

      if (priceTarget) {
        priceTarget.textContent = matchedVariant.price_formatted;
      }

      if (addButton) {
        addButton.disabled = !matchedVariant.available;
        addButton.textContent = matchedVariant.available ? addButton.dataset.addLabel : 'Sold out';
      }

      if (gallery && typeof gallery.setActiveMedia === 'function' && matchedVariant.featured_media_id) {
        gallery.setActiveMedia(matchedVariant.featured_media_id);
      }

      optionGroups.forEach((group, groupIndex) => {
        const radios = group.querySelectorAll('input');

        radios.forEach((radio) => {
          const testOptions = [...selectedOptions];
          testOptions[groupIndex] = radio.value;

          const exists = variants.some((variant) =>
            variant.available &&
            testOptions.every((value, index) => !value || variant.options[index] === value)
          );

          const pill = radio.closest('.selector-pill');
          radio.disabled = !exists;
          pill.classList.toggle('is-disabled', !exists);
          pill.classList.toggle('is-selected', radio.checked);
        });
      });
    };

    optionGroups.forEach((group) => {
      group.addEventListener('change', updateVariant);
    });

    if (visibleSelect) {
      visibleSelect.addEventListener('change', () => {
        masterSelect.value = visibleSelect.value;
        const selectedVariant = variants.find((variant) => String(variant.id) === visibleSelect.value);
        if (!selectedVariant) return;

        optionGroups.forEach((group, groupIndex) => {
          const radios = group.querySelectorAll('input');
          radios.forEach((radio) => {
            radio.checked = radio.value === selectedVariant.options[groupIndex];
          });
        });

        updateVariant();
      });
    }

    updateVariant();
  });

  document.querySelectorAll('[data-quantity-field]').forEach((field) => {
    const input = field.querySelector('input');
    const minus = field.querySelector('[data-quantity-minus]');
    const plus = field.querySelector('[data-quantity-plus]');
    if (!input || !minus || !plus) return;

    minus.addEventListener('click', () => {
      const value = Math.max(1, Number(input.value || 1) - 1);
      input.value = value;
    });

    plus.addEventListener('click', () => {
      const value = Math.max(1, Number(input.value || 1) + 1);
      input.value = value;
    });
  });
});
